import React from 'react';

import moment from 'moment';
import { Link } from 'react-router-dom';

import { formatCurrency } from '../../../../../../helpers/currencyMask';

export default function createActualCollectedTooltipContent(payments, loanId) {
  if (!payments || payments.length === 0) {
    return null;
  }

  return (
    <div>
      <h4 className="font-semibold mb-1">Payments</h4>
      <ul className="flex flex-col gap-1 list-disc pl-2">
        {payments.map((payment) => {
          const date = moment(payment.date).format('M/D/YY');
          const amount = formatCurrency(payment.amount);
          return (
            <li key={payment.id}>
              <Link
                to={`/loans/${loanId}/payments/${payment.id}?tab=Payment`}
                className="block underline text-indigo-500"
              >
                {date} - {payment.source} - ${amount}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
